import { atomWithReset } from 'jotai/utils'

import { type Survey, type SurveyGroupBrand } from '~/gql/graphql'
import { type DataDisplayType } from '~/utils'

import { type TableChartType } from '../utils'

export const tableChartTypeAtom = atomWithReset<TableChartType>('chart')
export const dataDisplayTypeAtom = atomWithReset<DataDisplayType>('percentage')
export const isChartMaxUnifiedAtom = atomWithReset(false)

type BrandId = SurveyGroupBrand['id']
type SurveyId = Survey['id']
export const hiddenBrandIdsAtom = atomWithReset<BrandId[]>([])
export const hiddenLabelBrandIdsAtom = atomWithReset<BrandId[]>([])
export const hiddenSurveyIdsAtom = atomWithReset<SurveyId[]>([])

export const commentAtom = atomWithReset<Record<string, string>>({})

export const savedCommentAtom = atomWithReset<Record<string, string>>({})
